import Base from './Base';
import Client from '../models/Client';

export default class Clients extends Base {
    get models() {
        const collection = this.data.map(item => new Client(item));
        collection.collection = this;

        return collection;
    }
}
